<template>
  <div id="table">
    <!--目前最新版本信息-->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%;border:1px solid #d7dae0;border-radius:10px;">
      <el-table-column
        label="ID"
        prop="date"
        width="180">
      </el-table-column>
      <el-table-column
        :label="this.id"
        prop="name"
        width="180">
      </el-table-column>
    </el-table>
    <!--日志-->
  </div>
</template>

<script>
import {changeInfo, productInfo} from "../api/api";

export default {
  name: "productInfo",
  data() {
    return {
      id: "",
      tableData: [{
        date: 'Batch',
        name: '',
      }, {
        date: 'Project',
        name: '',
      }, {
        date: 'Software version',
        name: '',
      }, {
        date: 'HardWare version',
        name: '',
      }, {
        date: 'Area code',
        name: '',
      }, {
        date: 'Date',
        name: '',
      }],
      dataLog: [],
      // logBol:false
      logBol: true
    }
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    //获取页面数据
    getData() {
      let path = this.$router.currentRoute.path;
      this.id = path.replace("/Q", "");
      //先判断手机号码是否一致
      let data = {sn: this.id};
      productInfo(this.id).then(res => {
        let {code, msg, data} = res;
        if (code === 0) {
          if(data.id){
            this.id = data.id;
          }
          this.tableData[0].name = data.batch;
          this.tableData[1].name = data.projectId;
          this.tableData[2].name = data.softVer;
          this.tableData[3].name = data.hardVer;
          this.tableData[4].name = data.region;
          this.tableData[5].name = data.minCreated;
        }
      })
      return
      changeInfo(this.id).then(res => {
        let {code, msg, data} = res;
        if (code === 0) {
          this.logBol = true
          this.dataLog = data;
          this.dataLog.forEach(value => {
            if (value.type === 0) {
              value.type = "生产"
            } else if (value.type === 1) {
              value.type = "升级"
            } else {
              value.type = "查询更新"
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
#table {
  top: 10px;
  position: absolute;
  right: 50%;
  margin-right: -180px;
}
</style>



// WEBPACK FOOTER //
// src/components/senasicInfo.vue